import React from "react";
import { FormattedMessage } from "react-intl";
import { Heading1 } from "../../../../components/value-cssmodules/TextComponent";

type Props = {
  update: boolean;
};

const Title: React.FC<Props> = ({ update }) => {
  return (
    <React.Fragment>
      <Heading1>
        {update ? (
          <FormattedMessage
            id={"product.editPattern"}
            defaultMessage={"Edit Pattern"}
          />
        ) : (
          <FormattedMessage
            id={"product.addPattern"}
            defaultMessage={"Add Pattern"}
          />
        )}
      </Heading1>
    </React.Fragment>
  );
};

export default Title;
